<template>
  <UiDropdown
    label="Network"
    :options="options"
    :modelValue="state.net"
    @update:modelValue="onChange"
    boxStyle="drop-height"
  ></UiDropdown>
</template>

<script setup>
import { onMounted, reactive, watch, watchEffect } from 'vue';
import UiDropdown from '@/components/UiDropdown.vue';
import { useNetwork } from '@/hooks';
import { switchEthChain } from '@/utils/wallet';
import { chains } from '@/constants';
import { notify } from '@kyvg/vue3-notification';
import { withWalletFlow } from '@/utils/with';

const network = useNetwork();

const options = [
  // {
  //   label: 'Ethereum',
  //   value: '',
  // },
  {
    label: 'Polygon',
    value: '',
  },
];

const state = reactive({
  net: {
    label: 'Polygon',
    value: '',
  },
});

const onChange = withWalletFlow(async (net) => {
  const flag = await switchEthChain(chains[net.label]);
  if (flag) {
    state.net = net;
  } else {
    notify({
      type: 'error',
      text: 'Switch Network Failed.',
    });
  }
});

// watchEffect(() => {
//   state.net = {
//     label: network.value,
//     value: '',
//   };
// });

watch(() => state.net);
</script>

<style scoped>
:deep(.drop-height) {
  height: 56px;
}
</style>
